import { CheckCircle } from 'lucide-react';
import { WHATSAPP_URL, DOCTOR_PHOTO_ABOUT } from '../constants';
import { useScrollReveal } from '../hooks/useScrollReveal';

const credentials = [
'Mais de 200 procedimentos de simpatectomia realizados',
'Título de Especialista em Cirurgia Torácica emitido pela SBCT',
'Atua nos melhores hospitais de Feira de Santana - BA',
'Altíssima taxa de satisfação com abordagem humanizada'];


export default function AboutSection() {
  const [ref, isVisible] = useScrollReveal();
  return (
    <section id="sobre" ref={ref} className={`py-24 md:py-32 bg-white transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Photo Left */}
          <div className="relative flex justify-center">
            <div className="relative w-full max-w-lg">
              <div className="rounded-3xl overflow-hidden shadow-xl flex items-center justify-center bg-gray-50">
                <img
                  src={DOCTOR_PHOTO_ABOUT}
                  alt="Dr. Mateus Marques - Cirurgião Torácico em Feira de Santana"
                  className="w-full h-auto object-contain"
                  loading="lazy" />

              </div>
              <div className="absolute -bottom-6 -right-6 bg-[#0D47A1] text-white rounded-2xl p-5 shadow-xl">
                <div className="font-poppins font-bold text-2xl">200+</div>
                <div className="text-white/75 text-xs font-medium">Simpatectomias</div>
              </div>
              <div className="absolute top-6 -left-6 bg-[#00897B] text-white rounded-2xl p-4 shadow-xl hidden lg:block">
                <div className="font-poppins font-bold text-xl">CRM-BA</div>
                <div className="text-white/80 text-xs">28.632</div>
              </div>
            </div>
          </div>

          {/* Text Right */}
          <div>
            <div className="inline-flex items-center bg-[#00897B]/10 text-[#00897B] rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
              Sobre o Especialista
            </div>
            <h2 className="font-poppins font-bold text-3xl sm:text-4xl text-[#212121] mb-6 leading-tight">
              A Quem Você Vai<br />Confiar Sua Mudança
            </h2>
            <p className="text-base md:text-lg text-[#212121]/75 leading-relaxed mb-4">
              O Dr. Mateus Marques é cirurgião torácico especializado em Simpatectomia Torácica, com atuação
              nos maiores hospitais de Feira de Santana.
            </p>
            <p className="text-base md:text-lg text-[#212121]/75 leading-relaxed mb-4">
              Graduou-se em Medicina pela Escola Bahiana de Medicina e Saúde Pública (Salvador-BA). Fez residência médica em Cirurgia Geral na Santa Casa de Misericórdia da Bahia (Salvador-BA) e concluiu residência em Cirurgia Torácica no Hospital Júlia Kubitschek (Belo Horizonte - MG), referência nacional no tratamento de doenças torácicas.
            </p>
            <p className="text-base md:text-lg text-[#212121]/75 leading-relaxed mb-8">
              Mas o diferencial não é apenas técnica — é o cuidado. Ele entende que hiperidrose afeta sua
              confiança, seus relacionamentos, sua carreira. Por isso cada consulta é uma conversa real.
            </p>

            <ul className="space-y-3 mb-8">
              {credentials.map((cred, i) =>
              <li key={i} className="flex items-start gap-3">
                  <CheckCircle size={20} className="text-[#00897B] mt-0.5 flex-shrink-0" />
                  <span className="text-[#212121]/80 text-sm md:text-base">{cred}</span>
                </li>
              )}
            </ul>

            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-cta-button"
              className="inline-flex items-center gap-2 bg-[#0D47A1] text-white font-poppins font-bold px-8 py-4 rounded-full hover:bg-[#00897B] transition-colors duration-200 shadow-lg hover:-translate-y-0.5 hover:shadow-xl">

              AGENDAR CONSULTA COM ESPECIALISTA
            </a>
          </div>

        </div>
      </div>
    </section>);

}